import React from 'react';

const TasksTimelineCard = ({ execution }) => {
    return (    
    <div className="timeline-block mb-3">
      <span className="timeline-step">
        <i className="material-icons text-success text-gradient">notifications</i>
      </span>
      <div className="timeline-content">
        <h6 className="text-dark text-sm font-weight-bold mb-0">{execution.executionOutput}s</h6>
        <p className="text-secondary font-weight-bold text-xs mt-1 mb-0">{execution.executionTimestamp}</p>
      </div>
    </div>


    );
}

export default TasksTimelineCard;